import { PersonaCategoriaTipoCategoriaAreaLogicaModel } from "./persona-categoria-tipo-categoria-area-logica.model";

export class PersonaCategoriaTipoCategoriaModel {
  id: number = 0;
  codigo: string = '';
  acronimo: string = '';
  nombre: string = '';
  descripcion: string = '';
  areaLogicaId: number = 0;
  areaLogica: PersonaCategoriaTipoCategoriaAreaLogicaModel = new PersonaCategoriaTipoCategoriaAreaLogicaModel();

  constructor() { }
}
